import { render } from "./EditorComponent.vue?vue&type=template&id=72cabb84&scoped=true"
import script from "./EditorComponent.vue?vue&type=script&lang=js"
export * from "./EditorComponent.vue?vue&type=script&lang=js"

import "./EditorComponent.vue?vue&type=style&index=0&id=72cabb84&scoped=true&lang=less"

import exportComponent from "/Users/yulian/DEVELOPMENT/g2-rtf-editor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72cabb84"]])

export default __exports__